module.exports = __webpack_public_path__ + "static/img/page3.f5fefec.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/page3.jpg
// module id = ihhz
// module chunks = 2